module.exports = __webpack_public_path__ + "static/neonbrand-unsplash-038ba334ef94aa2f61515dc2fa3d4c7b.jpg";